import { ReactNode } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppShell({ children }: { children: ReactNode }) {
    return (
        <div className="min-h-screen md:flex">
            <Sidebar />
            <main className="flex-1 p-4 md:p-8">
                <Topbar />
                {children}
            </main>
        </div>
    );
}